import {ApplianceRaw} from 'components/customer/Product/Appliance/entity/Appliance';

export const getSavedRangehoodHeight = (
    jobCabinetAppliances?: ApplianceRaw[]
): number | undefined => {
    const rangehood = jobCabinetAppliances?.find(
        (appliance) => appliance.appliance_type == 'rangehood'
    );
    const height = Number(rangehood?.height);

    return height > 0 ? height : undefined;
};
